import axios from 'axios';
import { FlowScenario } from '../../types/flowScenario';
import { access_token, isTokenExpired, refreshAuthToken } from '../../utils/getAccessToken';
import { getURLFromFunctionName } from '../../utils/shared';

export async function validateCheckout(flowScenario: FlowScenario): Promise<boolean> {
  if (!access_token || isTokenExpired(access_token)) {
    await refreshAuthToken();
  }

  const response = await axios.post(
    getURLFromFunctionName('validateCheckout'),
    {
      data: {
        flowScenario,
      },
    },
    {
      headers: {
        Authorization: `Bearer ${access_token}`,
      },
    }
  );

  if (!response.data || !response.data.data) {
    throw new Error('No data found');
  }

  return response.data.data.status === 'complete';
}
